const activeEnums = [
  {
    key: false,
    value: "inactive",
  },
  {
    key: true,
    value: "active",
  },
];

Object.freeze(activeEnums);

const roleEnums = [
  {
    key: 0,
    value: "superAdmin",
  },
  {
    key: 1,
    value: "admin",
  },
];

Object.freeze(roleEnums);

const SERVICE_PROVIDER_VALUES = {
  SIMPLE: "simple",
  BARION: "barion",
  CMFX: "cmfx",
  SZAMLAZZ_HU: "szamlazz_hu",
  SZEP_CARD: "szep_card",
};

const PAYMENT_PROVIDER = Object.freeze({
  SIMPLE: "simple",
  BARION: "barion", // not used yet
  SZEP_CARD: "szep_card",
});

const INVOICE_PROVIDER = Object.freeze({
  CMFX: "cmfx", // not used yet
  SZAMLAZZ_HU: "szamlazz_hu",
});

export {
  activeEnums,
  roleEnums,
  SERVICE_PROVIDER_VALUES,
  PAYMENT_PROVIDER,
  INVOICE_PROVIDER,
};
